import { FrontendStaffUser } from '../../../services/staff/staffService';
import { RevenueSourceType } from '../../../types/RevenueSourceType';

/** 'mixed' means the member is restricted to food AND drinks (both badges), which is
 *  not the same as 'all' (no restriction at all). */
export type AccessType = 'all' | 'food' | 'drinks' | 'mixed';

export const getAccessTypeFromRestrictions = (
  access: { allowed_revenue_source_types?: RevenueSourceType[] | null } | undefined
): AccessType => {
  if (!access?.allowed_revenue_source_types || access.allowed_revenue_source_types.length === 0) {
    return 'all';
  }
  const types = access.allowed_revenue_source_types;
  const hasFood = types.includes(RevenueSourceType.FOOD);
  const hasDrinks = types.includes(RevenueSourceType.DRINKS);
  if (hasFood && !hasDrinks) return 'food';
  if (hasDrinks && !hasFood) return 'drinks';
  if (hasFood && hasDrinks) return 'mixed';
  return 'all';
};

/**
 * The single access badge for a card header, or null when the member's restaurants
 * disagree. Only badges when EVERY restaurant carries the same non-'all' restriction —
 * a member restricted in one restaurant but unrestricted in another gets no badge,
 * because one label would misrepresent the other restaurant.
 */
export const getHeaderAccessType = (user: FrontendStaffUser): AccessType | null => {
  const accessTypes = user.restaurant_ids.map((rid) =>
    getAccessTypeFromRestrictions(user.restaurant_access?.[rid])
  );
  const nonAllTypes = accessTypes.filter((type) => type !== 'all');
  const uniqueNonAllTypes = Array.from(new Set(nonAllTypes));
  return uniqueNonAllTypes.length === 1 && nonAllTypes.length === user.restaurant_ids.length
    ? uniqueNonAllTypes[0]
    : null;
};
